import React from 'react';
import Helmet from 'react-helmet';
import Header from './Header';
import Footer from './Footer';
import favicon from '../assets/favicon.ico';

import './Layout.css';

export default function Layout({ className = '', children }) {
  return (
    <div className="sc-redesign">
      <Helmet
        link={[
          { rel: 'shortcut icon', type: 'image/ico', href: `${favicon}` }
        ]}
      />
      <Header />
      <main className={`sc-main ${className}`.trim()}>{children}</main>
      <div className="sc-footer-wrap">
        <Footer />
      </div>
    </div>
  );
}
